import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Admin users service.
 *
 * @author Ihar Kazlouski
 * @class AdminUsersServiceClass
 * @category Services
 */
var AdminUsersServiceClass = /*#__PURE__*/function () {
  function AdminUsersServiceClass() {
    _classCallCheck(this, AdminUsersServiceClass);
  }

  _createClass(AdminUsersServiceClass, [{
    key: "apiAdminUsersGet",
    value:
    /**
     * Admin console users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminUsersResponseType>>} admin console users.
     */
    function () {
      var _apiAdminUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/admin-console-users', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiAdminUsersGet(_x) {
        return _apiAdminUsersGet.apply(this, arguments);
      }

      return apiAdminUsersGet;
    }()
    /**
     * Admin console groups get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminGroupsResponseType[]>>} admin console groups.
     */

  }, {
    key: "apiAdminGroupsGet",
    value: function () {
      var _apiAdminGroupsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiGet('/names', _objectSpread({
                  prefixURL: '/admin-console-groups'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiAdminGroupsGet(_x2) {
        return _apiAdminGroupsGet.apply(this, arguments);
      }

      return apiAdminGroupsGet;
    }()
    /**
     * Admin console users filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<AdminUsersResponseType>>} admin console users list promise.
     */

  }, {
    key: "apiSearchAdminUsersPost",
    value: function () {
      var _apiSearchAdminUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPost('/admin-console-users/search', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiSearchAdminUsersPost(_x3) {
        return _apiSearchAdminUsersPost.apply(this, arguments);
      }

      return apiSearchAdminUsersPost;
    }()
    /**
     * Admin console user update put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiUpdateAdminUserPut",
    value: function () {
      var _apiUpdateAdminUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPut("/admin-console-user/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiUpdateAdminUserPut(_x4, _x5) {
        return _apiUpdateAdminUserPut.apply(this, arguments);
      }

      return apiUpdateAdminUserPut;
    }()
    /**
     * Admin console user post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiAddAdminUserPost",
    value: function () {
      var _apiAddAdminUserPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiPost("/admin-console-users/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiAddAdminUserPost(_x6, _x7) {
        return _apiAddAdminUserPost.apply(this, arguments);
      }

      return apiAddAdminUserPost;
    }()
    /**
     * Admin console user post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<UploadAllUsersResponse[]>} promise.
     */

  }, {
    key: "apiUploadFilePost",
    value: function () {
      var _apiUploadFilePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiPost("/admin-user/file/upload/".concat(params === null || params === void 0 ? void 0 : params.id), params.body.file, {
                  prefixURL: '/admin'
                }, true, true));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function apiUploadFilePost(_x8) {
        return _apiUploadFilePost.apply(this, arguments);
      }

      return apiUploadFilePost;
    }()
    /**
     * Admin console user post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<UploadAllUsersResponse[]>} promise.
     */

  }, {
    key: "apiUploadUsersPost",
    value: function () {
      var _apiUploadUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiPost("/admin-user/upload/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function apiUploadUsersPost(_x9, _x10) {
        return _apiUploadUsersPost.apply(this, arguments);
      }

      return apiUploadUsersPost;
    }()
    /**
     * Partial update current admin info patch api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} current admin response promise.
     */

  }, {
    key: "apiUpdateAdminInfoPatch",
    value: function () {
      var _apiUpdateAdminInfoPatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", ApiService.apiPatch("/admin-console-users/".concat(params.body.id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function apiUpdateAdminInfoPatch(_x11) {
        return _apiUpdateAdminInfoPatch.apply(this, arguments);
      }

      return apiUpdateAdminInfoPatch;
    }()
    /**
     * Admin console delete post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>>} response.
     */

  }, {
    key: "apiDeleteUsersPost",
    value: function () {
      var _apiDeleteUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", ApiService.apiPost("/delete/".concat(params.id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function apiDeleteUsersPost(_x12) {
        return _apiDeleteUsersPost.apply(this, arguments);
      }

      return apiDeleteUsersPost;
    }()
    /**
     * Block user put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiBlockAdminUserPut",
    value: function () {
      var _apiBlockAdminUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id, params) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", ApiService.apiPut("/block/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function apiBlockAdminUserPut(_x13, _x14) {
        return _apiBlockAdminUserPut.apply(this, arguments);
      }

      return apiBlockAdminUserPut;
    }()
    /**
     * Unblock user put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiUnBlockAdminUserPut",
    value: function () {
      var _apiUnBlockAdminUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id, params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", ApiService.apiPut("/unblock/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function apiUnBlockAdminUserPut(_x15, _x16) {
        return _apiUnBlockAdminUserPut.apply(this, arguments);
      }

      return apiUnBlockAdminUserPut;
    }()
    /**
     * Admin console refresh pin post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>>} response.
     */

  }, {
    key: "apiRefreshPinPost",
    value: function () {
      var _apiRefreshPinPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", ApiService.apiPost("/refresh-pin/".concat(params.id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/auth'
                }, params)));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function apiRefreshPinPost(_x17) {
        return _apiRefreshPinPost.apply(this, arguments);
      }

      return apiRefreshPinPost;
    }()
  }]);

  return AdminUsersServiceClass;
}();

var AdminUsersService = new AdminUsersServiceClass();
export { AdminUsersService };